<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 958.58 595.28">
    <g id="Locations">
        <circle class="cls-1" cx="44.42" cy="320.08" r="7.65" transform="translate(-30.47 5.73) rotate(-5.5)"/>
        <path class="cls-1" d="M831.68,290.79a7.65,7.65,0,1,0,3.7,10.16A7.65,7.65,0,0,0,831.68,290.79Z"/>
        <g id="Group_1855-2" data-name="Group 1855">
            <path id="Path_1-2" data-name="Path 1" class="cls-2" d="M831.25,298.53C612,225,522.86,203.11,175.72,239c-50,7.31-59.21,83.92-127.82,82.9"/>
        </g>
    </g>
</svg>